import * as API from '@/api'
import DEFINES from '@/defines'
import {getField, updateField} from 'vuex-map-fields';
//initial state
function initialState() {
    return {
        list:[]
    }
}
const state = initialState()

// actions

const actions = {

    async list(context,payload) {
        var response = await API.adminUser.list(payload)
        context.commit('set_list', {
            users: response.users,
        })
        return response;
    },

    async deleteUserDetails(context,payload) {
        await API.adminUser.deleteUserDetails(payload);
    }
}


//getters

const getters = {
    getField,
    getList: (state) => {
        return state.list
    },
    getUserFromId: (state) => (user_id) => {
        var user = state.list.find(user => {
            return user.id == user_id
        });
        return user;
    }
}


// mutations
const mutations = {
    updateField,
    set_list(state,payload) {
        state.list = payload.users
    },

    reset (state) {
        // acquire initial state
        const s = initialState ();
        Object.keys (s).forEach (key => {
            state[key] = s[key];
        });
    },
}

export default {
    namespaced: true,
    state,
    actions,
    getters,
    mutations
}
